<template>
  <table id="tabCluster">
    <tr>
      <td class="desc-title headTd">{{title}}</td>
      <td colspan="2">
        <select v-model.lazy="selected" @change="selectedValue()" class="form-control form-control-sm">
          <option value="-">-</option>
          <option value="PRA-AD604">PRA-AD604 (600 W-4 {{ $t("message.channel") }})</option>
          <option value="PRA-AD608">PRA-AD608 (600 W-8 {{ $t("message.channel") }})</option>
          <option value="PRA-ES8P2S">PRA-ES8P2S (8xPoE + 2xSFP)</option>
          <option value="other">{{ $t("message.otherDevice") }}</option>
        </select>
      </td>
    </tr>
    <template v-if="selected === 'PRA-AD604'">
      <tr>
        <td></td> <!-- <span v-if="ethernet4 === 0 || ethernet4 === '0'" class="info">min. 1</span> -->
        <td class="device-content">{{ $t("message.mpsActiveEthernet") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=1 max=2
          v-model.lazy="ethernet4" @change="inputValue()" name="ethernet4" @input="addEvent"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.totalLoudspeaker") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=600
          v-model.lazy="loudspeaker4" @change="inputValue()" name="loudspeaker4" @input="addEvent"/>
        </td>
      </tr>
      <tr><td></td><td></td><td></td></tr>
      <tr class="wiersz-pusty"></tr>
    </template>
    <template v-if="selected === 'PRA-AD608'">
      <tr>
        <td></td> <!-- <span v-if="ethernet8 === 0 || ethernet8 === '0'" class="info">min. 1</span> -->
        <td class="device-content">{{ $t("message.mpsActiveEthernet") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=1 max=2
          v-model.lazy="ethernet8" @change="inputValue()" name="ethernet8" @input="addEvent"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.totalLoudspeaker") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=600
          v-model.lazy="loudspeaker8" @change="inputValue()" name="loudspeaker8" @input="addEvent"/>
        </td>
      </tr>
      <tr><td></td><td></td><td></td></tr>
      <tr class="wiersz-pusty"></tr>
    </template>
    <template v-if="selected === 'PRA-ES8P2S'">
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.mpsActiveEthernet") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=8
          v-model.lazy="ethernet" @change="inputValue()" name="ethernet" @input="addEvent"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.mpsActiveSfp") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=2
          v-model.lazy="sfp" @change="inputValue()"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.totalPoE") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=120
          v-model.lazy="poe" @change="inputValue()" name="poe" @input="addEvent"/>
        </td>
      </tr>
      <tr class="wiersz-pusty"></tr>
    </template>
    <template v-if="selected === 'other'">
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.currentQuiescent") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=5500
          v-model.lazy="currentMode" @change="inputValue()"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.currentAlarm") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=5500
          v-model.lazy="currentAlarm" @change="inputValue()" name="currentAlarm" @input="addEvent"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.heightOtherDivice") }}</td>
        <td class="qty-content">
          <input type="number" class="form-control form-control-sm" min=0 max=10
          v-model.lazy="countU" @change="inputValue()" name="countU" @input="addEvent"/>
        </td>
      </tr>
      <tr><td></td><td></td><td></td></tr>
      <tr class="wiersz-pusty"></tr>
    </template>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Output48',
  props: ['title', 'values', 'clear'],
  data () {
    return {
      selected: '-',
      ethernet4: 0,
      loudspeaker4: 0,
      ethernet8: 0,
      loudspeaker8: 0,
      ethernet: 0,
      sfp: 0,
      poe: 0,
      currentMode: 0,
      currentAlarm: 0,
      countU: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.selected = '-'
        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.ethernet = 0
        this.sfp = 0
        this.poe = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.selected = '-'
        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.ethernet = 0
        this.sfp = 0
        this.poe = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.selected = this.values.selected
        if (this.values.selected === 'PRA-AD604') {
          this.ethernet4 = this.values.ethernet
          this.loudspeaker4 = this.values.loudspeaker
        } else if (this.values.selected === 'PRA-AD608') {
          this.ethernet8 = this.values.ethernet
          this.loudspeaker8 = this.values.loudspeaker
        } else {
          this.ethernet = this.values.ethernet
        }
        this.sfp = this.values.sfp
        this.poe = this.values.poe
        this.currentMode = this.values.currentMode
        this.currentAlarm = this.values.currentAlarm
        this.countU = this.values.countU
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clearing'])
  },
  methods: {
    addEvent ({ type, target }) {
      if (target.max) {
        if (Number(target.max) < Number(target.value)) {
          target.value = target.max
          this[target.name] = target.max
        }
      }
    },
    selectedValue () {
      if (this.selected === 'PRA-AD604') {
        this.ethernet4 = 1
        this.loudspeaker4 = 600

        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.sfp = 0
        this.poe = 0
        this.ethernet = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
        this.$emit('allValues', this.selected, this.ethernet4, this.loudspeaker4, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      } else if (this.selected === 'PRA-AD608') {
        this.ethernet8 = 1
        this.loudspeaker8 = 600

        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.sfp = 0
        this.poe = 0
        this.ethernet = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
        this.$emit('allValues', this.selected, this.ethernet8, this.loudspeaker8, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      } else if (this.selected === 'PRA-ES8P2S') {
        this.ethernet = 0
        this.sfp = 0
        this.poe = 0

        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
        this.$emit('allValues', this.selected, this.ethernet, this.loudspeaker4, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      } else if (this.selected === 'other') {
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0

        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.ethernet = 0
        this.sfp = 0
        this.poe = 0
      } else {
        this.ethernet = 0
        this.ethernet4 = 0
        this.loudspeaker4 = 0
        this.ethernet8 = 0
        this.loudspeaker8 = 0
        this.sfp = 0
        this.poe = 0
        this.currentMode = 0
        this.currentAlarm = 0
        this.countU = 0
        this.$emit('allValues', this.selected, this.ethernet, this.loudspeaker4, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      }
    },
    inputValue () {
      if (this.selected === 'PRA-AD604') {
        this.$emit('allValues', this.selected, this.ethernet4, this.loudspeaker4, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      } else if (this.selected === 'PRA-AD608') {
        this.$emit('allValues', this.selected, this.ethernet8, this.loudspeaker8, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      } else {
        this.$emit('allValues', this.selected, this.ethernet, this.loudspeaker4, this.sfp, this.poe, this.currentMode, this.currentAlarm, this.countU)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices/Output48.vue